import { render, staticRenderFns } from "./OrderHome.vue?vue&type=template&id=2d333622&"
import script from "./OrderHome.vue?vue&type=script&lang=js&"
export * from "./OrderHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports